import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../../Core/Link';

export const Tile = styled.div`
  font-weight: ${themeGet('fontWeights.normal')};
  width: 100%;
`;

export const Card = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-shadow: -1px 3px 8px rgba(0, 0, 0, 0.2);
  padding: 1rem 1.75rem;
  margin-bottom: 24px;
  width: 100%;
  min-height: 168px;
  overflow: hidden;
`;

export const CardBackground = styled.figure`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${themeGet('colors.white')};
  background-image: ${({ background }) => background && `url(${background})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  transition: width 300ms cubic-bezier(0.19, 1, 0.22, 1);
`;

export const Tag = styled.span`
  position: absolute;
  top: 0;
  left: 1.75rem;
  width: 4rem;
  height: 1rem;
  background-color: ${themeGet('colors.black')};
  color: ${themeGet('colors.white')};
  font-size: 0.6875rem;
  line-height: 0.8125rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: ${themeGet('fontWeights.normal')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3rem;
  letter-spacing: -0.28px;
  max-width: 150px;
  width: 100%;
  z-index: 1;
  margin: 10px 0;

  span {
    display: block;
    font-weight: ${themeGet('fontWeights.medium')};
    color: ${themeGet('colors.pc-red')};
  }
`;

export const Image = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  display: none;
  transition: all 300ms ease;
  z-index: 99;
`;

export const VideoTileWrapper = styled.div`
  width: 100%;
  margin: 0 auto 2rem;
  align-items: flex-start;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    margin: 10px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    max-width: 300px;
  }

  @media only screen and (min-width: 660px) {
    max-width: 280px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0 auto 1.5rem;
    max-width: 300px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 270px;
    margin: 0 auto 3.5rem;
  }

  @media only screen and (min-width: 1440px) {
    max-width: 285px;
  }
`;

export const StyledLink = styled(Link)`
  &:hover,
  &:focus {
    ${Image} {
      display: block;
    }

    ${CardBackground} {
      transition: width 500ms cubic-bezier(0.19, 1, 0.22, 1);
      width: 105%;
    }
  }
`;

export const TimeStamp = styled.span`
  position: absolute;
  bottom: 0.25rem;
  right: 0.25rem;
  padding: 0.25rem 0.5rem;
  background-color: rgba(0, 0, 0, 0.8);
  color: ${themeGet('colors.white')};
  font-size: 0.6875rem;
  line-height: 0.8125rem;
  display: flex;
  align-items: center;
  justify-content: center;

  ${StyledLink}.unstyled-link & {
    padding: 0.25rem 0.5rem;
  }
`;
